import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './bulk-archive-report-instances-dialog.controller';
import template from './bulk-archive-report-instances-dialog.html';

import bulkArchiveReportInstance from './bulkArchiveReportInstance';
import bulkArchiveReportInstancesConfirmDialog from '../dialog.bulkArchiveReportInstancesConfirmDialog';

class dialogService {
  getOptions($event, { reportType, reportInstances }) {
    return {
      controller,
      controllerAs: 'bulkArchiveReportInstancesDialogVM',
      locals: {
        reportType,
        reportInstances,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.myReports.reportType.bulkArchiveReportInstancesDialog', [
  ngCookies,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkArchiveReportInstance,
  bulkArchiveReportInstancesConfirmDialog,
])
  .service('bulkArchiveReportInstancesDialog', dialogService)
  .name;
